import { createAction } from 'redux-actions'

export const clearCurrentUser = createAction('CLEAR_CURRENT_USER')
